import { createContext, useState } from "react"

export const AppContext = createContext(null)

export function AppProvider({children}){
    const [userInfo, setUserInfo] = useState({email: '', firstName: ''})
    const [isLoggedIn, setIsloggedIn] = useState(false)
    const [role, setRole] = useState('')

    return(
        <AppContext.Provider
        value={{
            userInfo,
            isLoggedIn,
            setUserInfo,
            setIsloggedIn,
            role,
            setRole
        }}>
            {children}
        </AppContext.Provider>
    )
}